import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Text,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  useToast,
  Box,
} from "@chakra-ui/react";
import api from "utils/api";

export default function KmSetModal({ isOpen, onClose, aracData, onSuccess }) {
  const toast = useToast();
  const [km, setKm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!aracData?.cihaz_id) return;
    const kmValue = Number(km);
    if (!Number.isFinite(kmValue) || kmValue < 0) {
      toast({
        title: "Geçersiz KM",
        description: "Lütfen 0 veya daha büyük bir sayı girin.",
        status: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/api/telemetri/km-set", {
        device_id: Number(aracData.cihaz_id),
        km: kmValue,
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.detail || "KM set komutu gönderilemedi.");
      }
      toast({
        title: "Başarılı",
        description: `KM set komutu gönderildi (${kmValue} km).`,
        status: "success",
      });
      onSuccess?.();
      onClose?.();
      setKm("");
    } catch (err) {
      toast({
        title: "Hata",
        description: err.message,
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent borderRadius="xl">
        <ModalHeader>KM Set Et</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="md" p={3}>
              <Text fontSize="sm">
                Araç: <Text as="span" fontWeight="semibold">{aracData?.plaka || "-"}</Text>
              </Text>
              <Text fontSize="xs" color="gray.600">Cihaz ID: {aracData?.cihaz_id || "-"}</Text>
              <Text fontSize="xs" color="gray.600">IMEI: {aracData?.imei || "-"}</Text>
            </Box>

            <FormControl isRequired>
              <FormLabel fontSize="sm">Yeni KM Değeri</FormLabel>
              <Input
                type="number"
                min={0}
                step="0.1"
                placeholder="Örn: 125000"
                value={km}
                onChange={(e) => setKm(e.target.value)}
              />
              <FormHelperText>Değer doğrudan Traccar setOdometer komutuna gönderilir.</FormHelperText>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={2} onClick={onClose} isDisabled={loading}>
            İptal
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>
            KM Set Gönder
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
